export type LoginDto = {
  username: string;
  password: string;
};

export enum TokenGrantType {
  PasswordRealm = 'password_realm',
  RefreshToken = 'refresh_token',
}

export const CLAIMS_TOKEN = 'http://facephi.com/identity/claims/';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ClaimsType = { [key in string]: any };

export enum ClaimsList {
  tenant = 'tenant',
}
